import { useConfigStore } from "@/stores/config"

export async function getLocales() {
  const { urls } = useConfigStore()

  const url = `${urls.cdn}/locales.json`

  const response = await fetch(url, {
    method: "get",
    headers: {
      "Content-Type": "application/json",
    },
  })

  return response.json()
}
